/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Norecipients3Inputs */

const en_coinvestments_senddrafts_norecipients3 = /** @type {(inputs: Coinvestments_Senddrafts_Norecipients3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recipients`)
};

/**
* | output |
* | --- |
* | "No recipients" |
*
* @param {Coinvestments_Senddrafts_Norecipients3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_norecipients3 = /** @type {((inputs?: Coinvestments_Senddrafts_Norecipients3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Norecipients3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_norecipients3(inputs)
});
export { coinvestments_senddrafts_norecipients3 as "coInvestments_sendDrafts_noRecipients" }